import ContractAggregateAPI from '../../../api/ContractAggregateAPI';
import ContractAggregate from '../../../models/contract/ContractAggregate';
import UnitOfMeasureAPI from '../../../api/UnitOfMeasureAPI';
import UnitOfMeasure from "../../../models/unitOfMeasure/UnitOfMeasure";
export default {
  async getAllContractAggregates({
                                   commit
                                 }, data) {
    const response = await new ContractAggregateAPI().getContracts(data);
    const allAggreagates = [];
    for (let i = 0; i < response.contracts.length; i++) {
      const element = response.contracts[i];
      const aggreagate = ContractAggregate.createFromData(element);
      allAggreagates.push(aggreagate);
    }
    let errors = [];
    for (let i = 0; i < response.errors.length; i++) {
      errors.push(response.errors[i]);
    }
    commit("SET_ALL_CONTRACT_AGGREGATES", allAggreagates);
    return response;
  },

  async getCount({commit}, data) {
    const response = await new ContractAggregateAPI().getCount(data);
    return response;
  },

  async getContractAggregateById({
                                   commit
                                 }, id) {
    const response = await new ContractAggregateAPI().getContractById(id);
    const aggreagate = ContractAggregate.createFromData(response);
    commit("SET_CURRENT_CONTRACT", aggreagate);
    return aggreagate;
  },

  async getContractAggregateByIdAndEventId({
                                             commit
                                           }, data) {
    const response = await new ContractAggregateAPI().getContractByIdAndEventId(data);
    const aggreagate = ContractAggregate.createFromData(response);
    commit("SET_CURRENT_CONTRACT", aggreagate);
    return aggreagate;
  },

  async getUnitOfMeasure({
                           commit
                         }) {
    const response = await new UnitOfMeasureAPI().getUnitOfMeasure();
    const result = [];
    for (let i = 0; i < response.length; i++) {
      result.push(UnitOfMeasure.createFromData(response[i]));
    }
    commit("SET_UNIT_OF_MEASURE", result);
  },

  async createContract({
                         state,
                         commit
                       }, data) {
    let lessorCounterpartyIds = [];
    for (let i = 0; i < state.addedLessorsIds.length; i++) {
      if (state.addedLessorsIds[i] !== '') {
        lessorCounterpartyIds.push(state.addedLessorsIds[i]);
      }
    }
    state.currentContract.contract.lessorCounterpartyIds = lessorCounterpartyIds;
    const useRole = localStorage.getItem('useRole');
    state.currentContract.contract.status = useRole === 'true' ? 1 : 5;
    state.currentContract.assetComponents = data.assetComponents;
    const convertedModel = ContractAggregate.convertToSendData(state.currentContract);
    const response = await new ContractAggregateAPI().createContract(convertedModel);
    const contractAggreaget = ContractAggregate.createFromData(response);
    commit('ADD_CONTRACT_AGGREGATE', contractAggreaget);
  },

  async updateContract({
                         state,
                         commit
                       }, payload) {
    await new ContractAggregateAPI().updateContract(payload.data, payload.contractId);
  },

  async updateContractSimplified({
                                   state,
                                   commit
                                 }, payload) {
    await new ContractAggregateAPI().updateContractSimplified(payload.data, payload.contractId);
  },

  async contractImport({
                         commit
                       }, data) {
    return await new ContractAggregateAPI().excelImport(data);
  },
  async paymentsImport({
                         commit
                       }, data) {
    return await new ContractAggregateAPI().excelImportPaymentsForContract(data);
  },
  async getContractPreview({
                             state,
                             commit
                           }, assetsComponents) {
    const contractForPreview = state.currentContract;

    let lessorCounterpartyIdsForPreview = [];
    for (let i = 0; i < state.addedLessorsIds.length; i++) {
      if (state.addedLessorsIds[i] !== '') {
        lessorCounterpartyIdsForPreview.push(state.addedLessorsIds[i]);
      }
    }
    const useRole = localStorage.getItem('useRole');
    console.log(useRole);
    if (useRole === 'false') {
      const role = localStorage.getItem('role');
      contractForPreview.contract.status = role.toLowerCase() === 'admin' ? 5 : 1;
    } else {
      contractForPreview.contract.status = state.currentContract.contract.status;
    }
    contractForPreview.contract.lessorCounterpartyIds = lessorCounterpartyIdsForPreview;
    contractForPreview.assetComponents = assetsComponents;
    const convertedModelForPreview = ContractAggregate.convertToSendData(contractForPreview);
    return await new ContractAggregateAPI().getContractPreview(convertedModelForPreview);
  }
};
